import { Component, default as React } from "react";
import { Link } from "react-router-dom";

class Footer extends Component<any, any> {

	public render() {
		return (
			<footer id="page-footer" className="bg-white border-top">
				<div className="content py-0">
					<div className="row font-size-sm">
						<div className="col-sm-6 order-sm-2 mb-1 mb-sm-0 text-center text-sm-right">
							Crafted with <i className="fa fa-heart text-danger"/> by Wake powered on <a
							className="font-w600" href="https://api.craftmania.cz/">CraftAPI</a>
						</div>
						<div className="col-sm-6 order-sm-1 text-center text-sm-left">
							<Link className="font-w600" to="https://craftmania.cz">CraftMania.cz</Link> © <span
							data-toggle="year-copy" className="js-year-copy-enabled">2021</span>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

export default Footer;
